// Lightweight attribution helpers.
// - captureRef/getRef: landing-variant A/B analytics (existing).
// - captureAff/getAff: influencer affiliate code (Lemon Squeezy affiliates).

const REF_KEY = 'fennest_ref';
const AFF_KEY = 'fennest_aff';

export function captureRef(ref: string): void {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.setItem(REF_KEY, ref);
  } catch {
    // sessionStorage can throw in private mode; attribution is best-effort.
  }
}

export function getRef(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return window.sessionStorage.getItem(REF_KEY);
  } catch {
    return null;
  }
}

// Affiliate code - kept separate from ref so A/B analytics stay clean.
// First-touch wins: never overwrite an existing value in this session.
export function captureAff(code: string): void {
  if (typeof window === 'undefined') return;
  const clean = (code || '').trim().slice(0, 64);
  if (!clean) return;
  try {
    if (window.sessionStorage.getItem(AFF_KEY)) return;
    window.sessionStorage.setItem(AFF_KEY, clean);
  } catch {
    // best-effort
  }
}

export function getAff(): string | null {
  if (typeof window === 'undefined') return null;
  try {
    return window.sessionStorage.getItem(AFF_KEY);
  } catch {
    return null;
  }
}

/**
 * Read `?aff=` from the current URL and stash it in sessionStorage.
 * Safe to call on every mount - first-touch wins so repeat visits
 * without the param don't clobber the original.
 */
export function captureAffFromUrl(): void {
  if (typeof window === 'undefined') return;
  try {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('aff');
    if (code) captureAff(code);
  } catch {
    // ignore
  }
}
